'use client'

import { useEffect, useState } from 'react'
import { AUTH_COOKIES_CHANGED_EVENT, getAuthToken, getMembership } from '@/src/utils/authCookies'

/**
 * Client auth state synced with `auth_token` cookie: matches server `initialIsAuthenticated`
 * on load, then updates when login/logout sets or clears cookies (no full page reload).
 * `isMember` is true when the `membership` cookie equals the string `"true"`.
 */
export function useAuth(initialIsAuthenticated?: boolean) {
    const [isAuthenticated, setIsAuthenticated] = useState(!!initialIsAuthenticated)
    const [isMember, setIsMember] = useState(false)

    useEffect(() => {
        setIsAuthenticated(!!initialIsAuthenticated)
    }, [initialIsAuthenticated])

    useEffect(() => {
        const syncFromCookies = () => {
            setIsAuthenticated(!!getAuthToken())
            setIsMember(getMembership() === 'true')
        }
        syncFromCookies()
        window.addEventListener(AUTH_COOKIES_CHANGED_EVENT, syncFromCookies)
        return () => window.removeEventListener(AUTH_COOKIES_CHANGED_EVENT, syncFromCookies)
    }, [])

    return { isAuthenticated, isMember }
}
